<template>
  <div class="start flex-grow-1 flex-fill">
    <Translate />
    <section class="row">
      <div class="col-4 px-3 py-5 d-none d-md-flex"></div>
      <div class="col-24 col-md-16 px-3 align-items-center d-flex">
        <div class="row align-itens-center">
          <div
            class="col-24 col-md-11 min-h text-right justify-content-start align-items-end d-flex flex-column pr-3"
          >
            <img src="../../assets/svg/logo.svg" class="align-self-end mb-2" />
            <h1
              class="title"
              v-text="$ml.get('yourSecurityPlatformAndBugReward')"
            >
              A sua plataforma de segurança e recompensa por bugs
            </h1>
            <p v-text="$ml.get('youWillReceiveReportsFromCommunity')">
              Você recebe feedbacks dos especialistas de segurança da nossa
              comunidade, sem custo adicional, enquanto minimiza as chances de
              expor suas vulnerabilidades na mídia ou redes sociais
            </p>
            <router-link
              class="btn btn-outline mb-3"
              to="/register"
              v-text="$ml.get('iWantToCreateAnAccount')"
            >
              Quero criar uma conta!
            </router-link>
            <p
              class="normal mt-4 min-h d-none d-md-flex "
              v-text="$ml.get('doYouHaveOrganizationAndDidYou')"
            >
              Possui uma organização e gostou do projeto?
            </p>
            <p
              class="min-h d-none d-md-flex"
              v-text="$ml.get('letStartYourRegistrationAnd')"
            >
              Vamos iniciar seu cadastro e logo um especialista irá entrar em
              contato com você para esclarecer as dúvidas e finalizar seu
              cadastro!
            </p>
            <router-link
              to="/company"
              class="btn btn-outline"
              v-text="$ml.get('startAnAccountForOrganization')"
            >
              Iniciar uma conta para organização!
            </router-link>
          </div>
          <div
            class="col-2 min-h d-none d-md-flex justify-content-center py-3 d-none"
          >
            <span class="line align-self-center"></span>
          </div>
          <div
            class="col-24 col-md-11 min-h text-left justify-content-start align-items-end d-flex flex-column mt-5 pl-md-3"
          >
            <div class="card w-100">
              <div class="card-body">
                <h5 v-text="$ml.get('forgotYourPassword')">
                  Esqueceu sua senha?
                </h5>
                <p v-text="$ml.get('itHappensInTheBestFamilies')">
                  Acontece nas melhores famílias! Não se preocupe, basta colocar
                  seu e-mail e enviaremos uma nova senha.
                </p>
                <transition name="fade">
                  <div v-show="msgdanger" class="alert alert-danger">
                    {{ msgdanger }}
                  </div>
                </transition>
                <transition name="fade">
                  <div v-show="msgWarning" class="alert alert-warning">
                    {{ msgWarning }}
                  </div>
                </transition>
                <transition name="fade">
                  <div v-show="msgSuccess" class="alert alert-success">
                    <strong
                      v-text="$ml.get('anEmailContainingPasswordReset')"
                    ></strong
                    ><br />
                    <span v-show="msgSubSuccess"
                      ><font v-text="$ml.get('ifYouDontReceiveIt')"
                        >Caso não receba, poderá tentar de novo em</font
                      >
                      {{ seconds }}
                      <font v-text="$ml.get('seconds')">segundos</font>.</span
                    >
                  </div>
                </transition>
                <form @submit.prevent="tryToReset">
                  <div class="row mb-1">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="email"
                          :placeholder="$ml.get('yourEmail')"
                        />
                        <transition name="fade">
                          <label
                            v-if="emailError && !$v.email.required"
                            class="lblError"
                            v-text="$ml.get('enterTheEmail')"
                            >Digite o e-mail</label
                          >
                          <label
                            class="lblError"
                            v-if="emailError && !$v.email.email"
                            v-text="$ml.get('emailDoesNotAppearToBeValid')"
                            >Este e-mail não parece estar válido</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center mb-4">
                    <RecaptchaV2 ref="recaptcha" @verify="setRecaptchaToken" @expired="tokenRecaptcha = ''"/>
                  </div>
                  <div class="row">
                    <button
                      :disabled="disableBtn || !tokenRecaptcha"
                      class="btn btn btn-lg btn-block"
                    >
                      <Spinner v-show="loadingBtn" />
                      <span
                        v-show="!loadingBtn"
                        v-text="$ml.get('requestNewPassword')"
                        >Solicitar nova senha!</span
                      >
                    </button>
                  </div>
                  <div class="mt-3 text-center">
                    <router-link
                      to="/login"
                      class="row d-flex justify-content-center align-items-center"
                    >
                      <img
                        src="../../../src/assets/icons/lock-alt.svg"
                        class="ico-13 mx-2"
                      />
                      <font v-text="$ml.get('iAlreadyRemembered')"
                        >Eu já lembrei!</font
                      >
                    </router-link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";
import RecaptchaV2 from "../../components/recaptchaV2.vue";
import Translate from "../../components/translate.vue";

export default {
  components: {
    RecaptchaV2,
    Translate,
  },
  page: {
    title: "Recuperação de senha",
    meta: [{ name: "Forgot Password" }],
  },
  data() {
    return {
      email: "",
      submitted: false,
      emailError: false,
      loadingBtn: false,
      disableBtn: false,
      msgSubSuccess: false,
      seconds: 60,
      msgdanger: "",
      msgWarning: "",
      msgSuccess: "",
      tokenRecaptcha: ""
    };
  },
  validations: {
    email: { required, email },
  },
  computed:{
    preferredLanguage(){
        if(this.$ml.current == 'english'){
          return 'en'
        }else if(this.$ml.current == 'spanish'){
          return 'es'
        }
        return 'pt'
      },
  },  
  methods: {
    tryToReset() {
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.emailError = true;
        return;
      }
      this.emailError = false;
      this.loadingBtn = true;
      this.msgdanger = "";
      this.msgWarning = "";
      this.msgSuccess = "";
      this.msgSubSuccess = false;

      var self = this;
      delete axios.defaults.headers.common["Authorization"];
      axios
        .put(
          this.$store.getters["getApiUrl"] +
            `account/reset-password/send-email`,
          {
            email: this.email,
            tokenRecaptcha: this.tokenRecaptcha,
            language: this.preferredLanguage,
          }
        )
        .then(function(response) {
          self.loadingBtn = false;
          self.disableBtn = true;
          self.msgSuccess = response.data.msg;
          self.msgSubSuccess = true;

          var refreshInterval = setInterval(() => {
            if (self.seconds > 0) {
              self.seconds = self.seconds - 1;
            } else {
              clearInterval(refreshInterval);
              self.disableBtn = false;
              self.msgSubSuccess = false;
              self.seconds = 60;
            }
          }, 1000);
        })
        .catch(function(error) {
          self.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
          self.loadingBtn = false;
          if (error.response.status == 404) {
            self.msgWarning = error.response.data.message;
            return;
          }
          self.msgdanger = self.$ml.get("unableToCompleteThisRequest");
        });
    },
    setRecaptchaToken(token) {
      this.tokenRecaptcha = token
    },
  },
};
</script>

<style scoped>
.btnForm {
  width: 173px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.lblError {
  font-size: 11px;
  padding-left: 5px;
  color: red;
  position: absolute;
}
.form-group {
  margin-bottom: 20px;
}
</style>
